import axiosInstance from "@js-app/services/http/axios-instance";

class _UserApi {
    me() {
        return axiosInstance.get('/user', {
            withCredentials: true,
        });
    }

    async login(loginData) {
        return axiosInstance.post('/user/login', {
            login: loginData.login,
            password: loginData.password,
            'g-recaptcha-response': loginData['g-recaptcha-response'],
        }, {
            withCredentials: true,
        });
    }

    updateUser(newUserData) {
        return axiosInstance.post('/user', newUserData, {
            withCredentials: true,
        });
    }

    updateName(fistName, lastName) {
        return axiosInstance.post('/user', {
            FirstName: fistName,
            LastName: lastName,
        }, {
            withCredentials: true,
        });
    }

    updateTFA(isTfaEnabled) {
        return axiosInstance.post('/user', {
            OptionalParams: {
                "NoNeed2F": !isTfaEnabled
            }
        }, {
            withCredentials: true,
        });
    }

    updatePassword(userId, oldPassword, password) {
        return axiosInstance.post('/user/password', {
            user_id: userId,
            old_password: oldPassword,
            password,
        }, {
            withCredentials: true,
        });
    }

    logout() {
        return axiosInstance.post('/user/logout', {}, {
            withCredentials: true,
        });
    }

    getPermissions(companyId) {
        return axiosInstance.post('/user/permissions', {
            company_id: companyId,
        }, {
            withCredentials: true,
        });
    }

    sendResetPasswordOTP(hash, phone) {
        return axiosInstance.post('/auth/reset-password/send-otp', {
            hash,
            phone
        }, {
            withCredentials: true,
        });
    }

    verifyOTPCode(otpCode) {
        return axiosInstance.post('/auth/reset-password/verify-otp', {
            otp_code: otpCode
        }, {
            withCredentials: true,
        });
    }

    setNewPassword(password) {
        return axiosInstance.post('/auth/reset-password/set-password', {
            password
        }, {
            withCredentials: true,
        });
    }

    sendForgotPasswordLink(email) {
        return axiosInstance.post('/auth/forgot-password', {
            email
        }, {
            withCredentials: true,
        });
    }

    sendOTPCode(otpCode) {
        return axiosInstance.post('/user/login-otp', {
            otp_code: otpCode
        }, {
            withCredentials: true,
        });
    }
}

export const UserApi = new _UserApi();
